import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setAutoNavigation, setGoDown } from 'routes/MainPage/modules/mainPage';
import { getNarrative, getObjective, resetAll } from 'modules/steps/actions';
import { getOnGoingActivity } from 'modules/serendipity/actions';
import { resetContext } from 'store/globalState/global';
import { setBreadcrumb } from 'components/Navbar/modules';
import { selectDashboardElement } from 'components/Dashboard/modules/dashboard';
import { fetchElements } from '../modules';
import Narratives from '../components';


function mapStateToProps(state) {
  return {
    app: state.app,
    literals: state.i18n.literals.initiatives || {},
    narratives: state.narratives.list,
    objectives: state.narratives.objectives,
    tools: state.narratives.tools,
    elements: state.narratives.elements,
    itemsPreferencesFromSerendipity: state.serendipity.preferences,
    themeTables: state.thinkChats.myThinkChatsList,
    scheduleSpeedDatings: state.speedDating.meetings,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNarrative: bindActionCreators(getNarrative, dispatch),
    getObjective: bindActionCreators(getObjective, dispatch),
    setAutoNavigation: bindActionCreators(setAutoNavigation, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
    selectDashboardElement: bindActionCreators(selectDashboardElement, dispatch),
    setGoDown: bindActionCreators(setGoDown, dispatch),
    fetchElements: bindActionCreators(fetchElements, dispatch),
    getOnGoingActivity: bindActionCreators(getOnGoingActivity, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Narratives));



// WEBPACK FOOTER //
// ./src/routes/Narratives/container/index.js